import { defineComponent as _defineComponent } from 'vue'
import { AbSection, AbContainer, AbSectionLayout } from '../../../ui';
import { FormContainer } from '../../../../forms';

interface Props {
  id?: string | null;
  formId: string;
  successMessage?: {
    title: string;
    description: string;
    buttonText: string;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FormSectionSimple',
  props: {
    id: null,
    formId: null,
    successMessage: null
  },
  emits: ["submit", "submit-success", "submit-error", "form-start"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'submit', values: Record<string, any>): void;
  (e: 'submit-success'): void;
  (e: 'submit-error', error: string): void;
  (e: 'form-start'): void;
}), expose: any, slots: any, attrs: any }) {





const handleSubmit = (values: Record<string, any>) => {
  emit('submit', values);
};

const handleSubmitSuccess = () => {
  emit('submit-success');
};

const handleSubmitError = (error: string) => {
  emit('submit-error', error);
};

const handleFormStart = () => {
  emit('form-start');
};

return { __sfc: true,emit, handleSubmit, handleSubmitSuccess, handleSubmitError, handleFormStart, AbSection, AbContainer, AbSectionLayout, FormContainer }
}

})